import React from "react";
import axios, {AxiosPromise } from "axios";
import { NavigateFunction } from "react-router-dom";
import { ResponseParamBase } from "./Types";

const apiName: string | undefined = process.env.REACT_APP_API_NAME;
const baseUrl = window.location.protocol + "//" + window.location.host + apiName;//"https://localhost:7003/";

export type ResponseResultParam = {
    resultFlg: boolean,
    message: string
}

type RefreshToken = ResponseParamBase & {
    AccessToken: string,
    RefreshToken: string,
    jwtToken: string,
}

export function CvNull(obj: any): string {
    if (obj != null) {
        return obj;
    } else {
        return "";
    }
}

export type HttpResponse<T> = {
    message: string,
    json: T
}

export function HttpPostData<T>(path: string, param: Object, isLoading: React.Dispatch<React.SetStateAction<boolean>> | null): AxiosPromise<T> {//AxiosInstance {
/*
 * "Access-Control-Allow-Origin": window.location.origin,
            "Access-Control-Allow-Methods": "POST,GET,PUT,DELETE",
            "Access-Control-Allow-Headers": "Content-Type",
 **/

    axios.defaults.baseURL = baseUrl;//window.location.protocol + "//" + window.location.host + apiName;
    const createaxios = axios.create({
        headers: {
            "Content-Type": "application/json",            
            "Authorization": `Bearer ${window.localStorage.getItem('clickeracejwttoken')}` ,
        },
        responseType: "json",
    });
    let isRetry = false;

    createaxios.interceptors.request.use(config => {
        if (isLoading != null) isLoading(true);
        return config;
    });

    createaxios.interceptors.response.use(
        response => {
            //�������̓��X�|���X��Ԃ�            
            return response;
        },
        async function (error) {
            //�G���[��
            const originalRequest = error.config;
            if (error.response.status === 401 && !isRetry) {
                isRetry = true;

                return await createaxios.post<RefreshToken>("/authenticate/refresh-token-cookie",
                    {
                    }
                )
                    .then(res => {
                        if (res.status === 200) {                            
                            return createaxios(originalRequest);
                        }
                    })
                    .catch(() => {
                        return Promise.reject(error);
                    });
            } else {
                //�F�؈ȊO�̃G���[�Ŏ��s�����ꍇ
                return Promise.reject(error);
            }
        }
    );
    return createaxios.post(path, param).finally(() => {
        isLoading?.(false);
    });
}

export async function HttpPostInstance<T>(path: string, param: Object, isLoading: React.Dispatch<React.SetStateAction<boolean>> | null) {//AxiosInstance {
    axios.defaults.baseURL = baseUrl;//window.location.protocol + "//" + window.location.host + apiName;
    const createaxios = axios.create({
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${window.localStorage.getItem('clickeracejwttoken')}`,
        },
        responseType: "json",
    });
    let isRetry = false;

    createaxios.interceptors.request.use(config => {
        isLoading?.(true);
        return config;
    });

    createaxios.interceptors.response.use(
        response => {
            //�������̓��X�|���X��Ԃ�            
            return response;
        },
        async function (error) {
            //�G���[��
            const originalRequest = error.config;
            if (error.response.status === 401 && !isRetry) {
                isRetry = true;

                return await createaxios.post<RefreshToken>("/authenticate/refresh-token",
                    {
                    }
                )
                    .then(res => {
                        if (res.status === 200 && res.data.resultFlg) {
                            window.localStorage.setItem('clickeracejwttoken', res.data.jwtToken);
                            return createaxios(originalRequest, {
                                headers: {
                                    "Content-Type": "application/json",
                                    "Access-Control-Allow-Methods": "POST,GET,PUT,DELETE",
                                    "Access-Control-Allow-Headers": "Content-Type",
                                    "Authorization": `Bearer ${window.localStorage.getItem('clickeracejwttoken')}`,
                                },
                            });
                        }
                    })
                    .catch(() => {
                        return Promise.reject(error);
                    });
            } else {
                //�F�؈ȊO�̃G���[�Ŏ��s�����ꍇ
                return Promise.reject(error);
            }
        }
    );
    return await createaxios.post<T>(path, param)
        .finally(() => {
            isLoading?.(false);
        });
}

export async function DownloadFile(path: string, param: Object, isLoading: React.Dispatch<React.SetStateAction<boolean>> | null) {
    axios.defaults.baseURL = baseUrl;//window.location.protocol + "//" + window.location.host + apiName;
    const createaxios = axios.create({
        responseType: "blob",
        headers: {
            "Authorization": `Bearer ${window.localStorage.getItem('clickeracejwttoken')}`,
        }
    });

    createaxios.interceptors.request.use(config => {
        isLoading?.(true);
        return config;
    });

    const download = await createaxios.post(path, param)
        .then((response) => {
            const contentDisposition = response.headers["content-disposition"];
            const fileName = getFileNameFromHeader(contentDisposition)

            const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
        })
        .finally(() => {
            isLoading?.(false);
        });

    return download;
}

export async function GetDownloadFile(path: string, param: Object, isLoading: React.Dispatch<React.SetStateAction<boolean>> | null) {
    axios.defaults.baseURL = baseUrl;//window.location.protocol + "//" + window.location.host + apiName;
    const createaxios = axios.create({
        responseType: "blob",
        headers: {
            
        }
    });

    createaxios.interceptors.request.use(config => {
        isLoading?.(true);
        return config;
    });

    const download = await createaxios.get(path, param)
        .then((response) => {
            const contentDisposition = response.headers["content-disposition"];
            const fileName = getFileNameFromHeader(contentDisposition)

            const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
        })
        .finally(() => {
            isLoading?.(false);
        });

    return download;
}


function getFileNameFromHeader(content: string, defaultName = 'download.csv') {
    const regex = content.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
    if (regex === null) return defaultName;
    return decodeURI(regex[1]) || defaultName;
}

export function JumpPage<T>(path: string, param: T, title: string, navigate: NavigateFunction) {
    navigate(path.toLowerCase(), { state: param });
}

export const NumberFormatType = {
    Normal: '1',
    DoreMark: '2',
} as const

type NumberFormatType = typeof NumberFormatType[keyof typeof NumberFormatType];

export function FormatNumber(formatType: NumberFormatType, target?: number): string | undefined {
    if (formatType === NumberFormatType.DoreMark) {
        return "\\" + target?.toLocaleString("ja-JP", { maximumFractionDigits: 0 });
    }
    return target?.toLocaleString("ja-JP", { maximumFractionDigits: 0 });
}

export const DateFormatType = {
    YYYYMMDD: 'YYYY/MM/DD',
} as const

type DateFormatType = typeof DateFormatType[keyof typeof DateFormatType];

export function FormatDate(date: Date, formatType: DateFormatType): string {
    /*switch (formatType) {
        case DateFormatType.YYYYMMDD:
            return format(date, "YYYY/MM/DD");
        default:
            return format(date, "YYYY/MM/dd");
    }*/
    return "";
}
